export const HIDE_LAYOUT_BUTTON_ROUTE_LIST = [
  "/agent-commission/view",
  "/after-sales/view",
  "/after-sales/client-profile",
  "/agent-wallet-configuration/view",
  "/wallet-transactions/view"
];
